// Link represents a link in a REST API response

// Collection represents a collection of items in a REST API response
// int is sufficient for "Start" and "Count" because all target platforms are 64 bit
const CollectionMediaType = 'application/vnd.sas.collection';
export const CollectionMediaTypeJSON = `${CollectionMediaType}+json`;
//# sourceMappingURL=commons.js.map